export const SEND_EMAIL_LIST = 'SEND_EMAIL_LIST';
export const SEND_EMAIL_LIST_SUCCESS = 'SEND_EMAIL_LIST_SUCCESS';
export const SEND_EMAIL_LIST_FAILURE = 'SEND_EMAIL_LIST_FAILURE';

export const SET_NEW_PASSWORD = 'SET_NEW_PASSWORD';
export const SET_NEW_PASSWORD_SUCCESS = 'SET_NEW_PASSWORD_SUCCESS';
export const SET_NEW_PASSWORD_FAILURE = 'SET_NEW_PASSWORD_FAILURE';
